import {
  bigIntDecimalsDivision,
  bigIntDivision,
  bigIntFormat,
  bigIntMultiply,
  bigIntSum,
  BigNumber,
} from './bignumber';

export const formDate = (date: number) => {
  if (!date) return '';
  const lastUpdDate = new Date(Date.now() - date);
  const month = lastUpdDate.getMonth();
  const day = lastUpdDate.getDay();
  const year = lastUpdDate.getFullYear();
  const time = `${lastUpdDate.getHours()}:${lastUpdDate.getMinutes()}:${lastUpdDate.getSeconds()}`;
  return `${month}/${day}/${year} ${time}`;
};

export const formMegabytes = (bytes: number) => {
  if (!bytes) return '';
  const val = bigIntFormat(bigIntDivision(bytes.toString(), '1000000'));
  return `${numberFormatting(val)} MB`;
};

export function formatTransactionType(str: string) {
  str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
  str = str.toLowerCase(); // add space between camelCase text
  return str.toUpperCase();
}

const defaultOptions: Intl.NumberFormatOptions = {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
};

export const numberFormatting = (
  val: number | string | null,
  options: Intl.NumberFormatOptions = defaultOptions,
) => {
  if (val === null) return null;
  return (+val).toLocaleString('en', options);
};

export const numberFormattingBigNumberDivision = (
  number: string | BigNumber,
  division: string | BigNumber,
) => numberFormatting(bigIntFormat(bigIntDivision(number, division)));

export const numberFormattingBigIntSum = (num1: string | BigNumber, num2: string | BigNumber) =>
  numberFormatting(bigIntFormat(bigIntSum(num1, num2)));

export const numberFormattingBigIntMultiply = (
  num1: string | BigNumber,
  num2: string | BigNumber,
) => numberFormatting(bigIntFormat(bigIntMultiply(num1, num2)));
